// angle right

export const chevronRight = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 32">
<path d="M14.019 17.063l-8.5 8.5c-0.587 0.588-1.537 0.588-2.119 0l-1.413-1.412c-0.587-0.588-0.587-1.538 0-2.119l6.025-6.025-6.025-6.025c-0.587-0.588-0.587-1.538 0-2.119l1.406-1.425c0.588-0.588 1.538-0.588 2.119 0l8.5 8.5c0.594 0.588 0.594 1.537 0.006 2.125z"></path>
</svg>`;
